import getLocal from '@/app/utils/getLocal';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import styles from './index.module.scss';

export default function EmailBox({ contactListId, fields }: { contactListId: any; fields: any }) {
    const { locale } = getLocal();

    const tipsObj = locale === 'de' ? { btnText: 'Anmelden', placeholder: 'E-Mail Adresse eingeben' } : { btnText: '', placeholder: '' };
    return (
        <div className={`${styles.EmailBox}`}>
            <EfEmarsysEmail contactListId={contactListId} fields={fields} needTerms={true} tipsObj={tipsObj} isMulti={true} />
        </div>
    );
}
